"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHandleOnConfirm = void 0;
var _react = require("react");
var _functions = require("../../../page-body/site-search-results/utils/functions");
var _searchContext = require("./search-context");
/**
 * Handle confirmation callback for search functionality
 * @param {Function} search - Search function to execute
 * @returns {Function} Handle confirmation callback function
 */
const useHandleOnConfirm = search => {
  const {
    setSearchValue,
    searchStringMinLength,
    setValue,
    setIsActive,
    setStep
  } = (0, _searchContext.useInternalSearch)();
  return (0, _react.useCallback)((searchTerm, event, abortController) => {
    if (searchTerm?.length >= searchStringMinLength) {
      const keywordLowerCase = (0, _functions.sanitizeDomainQuery)(searchTerm.trim().toLowerCase());
      setValue(keywordLowerCase);
      setSearchValue(keywordLowerCase);
      search(keywordLowerCase, abortController);
    }
    if (event?.type === 'popstate' && searchTerm?.length === 0) {
      setSearchValue('');
    }
    setIsActive(false);
    setStep('results');
  }, [search, setSearchValue, searchStringMinLength, setValue, setIsActive, setStep]);
};
exports.useHandleOnConfirm = useHandleOnConfirm;